const featureItems = [
  {
    title: '全集免费完整版',
    desc: '樱花漫画网坚持所有漫画全集免费阅读，韩漫日漫国漫全本完整版没有任何隐藏收费，下拉式阅读体验全面开放，让每一位漫画爱好者都能畅享阅读乐趣。',
    icon: 'ri-vip-diamond-line',
  },
  {
    title: '下拉式流畅阅读',
    desc: '独创下拉式阅读模式，告别传统翻页的繁琐操作。像浏览网页一样自然滑动即可连续阅读完整章节，特别为手机端优化，带来极致的漫画阅读沉浸感。',
    icon: 'ri-scroll-to-bottom-line',
  },
  {
    title: '海量全本漫画资源',
    desc: '平台聚合超过20000部全本漫画作品，覆盖热血、恋爱、悬疑、奇幻、都市、校园、古风、科幻、惊悚等全部类型。热门连载每日同步更新，经典全本随时可看。',
    icon: 'ri-database-2-line',
  },
  {
    title: '多端同步无缝衔接',
    desc: '支持网页端与APP端无缝切换，阅读进度自动云端同步。无论是在电脑上浏览还是在手机上追更，都能获得一致的流畅体验，随时随地继续你的漫画之旅。',
    icon: 'ri-device-line',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50 scroll-mt-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-4">
          功能特色
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-xl mx-auto">
          为什么选择樱花漫画网？四大核心优势带给你最好的全集漫画阅读体验
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featureItems.map((item, idx) => (
            <div key={idx} className="group bg-background-100 rounded-xl p-6 border border-background-200/60 hover:border-primary-200 transition-all text-center">
              <div className="w-14 h-14 mx-auto flex items-center justify-center bg-primary-100 rounded-2xl mb-5 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-600 text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}